export default __webpack_public_path__ + "static/media/Snake_Square_White_Front_1.bffbdb4d.jpeg";